import React from "react";

import "./CaratSort.scss";

export type CaratSortProps = {
  cx?: string;
  text: string;
  state: number;
  setState: React.Dispatch<React.SetStateAction<number>>;
};

export const CaratSort: React.FC<CaratSortProps> = ({
  cx = "",
  text,
  state,
  setState,
}) => {
  return (
    <div
      className={`CaratSort ${cx}`}
      onClick={() => setState((a) => (a === 2 ? 0 : a + 1))}
    >
      <span>{text}</span>
      <svg
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#fff" fillOpacity=".01" d="M0 0h11v12H0z" />
        <path
          d="M5.5 11 3.335 7.25h4.33L5.5 11z"
          fill={state === 1 ? "#5fcefa" : "#111"}
        />
        <path
          d="m5.5 1 2.165 3.75h-4.33L5.5 1z"
          fill={state === 2 ? "#5fcefa" : "#111"}
        />
      </svg>
    </div>
  );
};
